export default __webpack_public_path__ + "static/Tinos-Regular-77f4801b3983c6d11181e70752152a99.woff";